module.exports = __webpack_public_path__ + "img/icon_change_arrow_pc.bc1a0de9.svg";